import { render, staticRenderFns } from "./RelSupervisor.vue?vue&type=template&id=266e1b28"
import script from "./RelSupervisor.vue?vue&type=script&lang=js"
export * from "./RelSupervisor.vue?vue&type=script&lang=js"
import style0 from "./RelSupervisor.vue?vue&type=style&index=0&id=266e1b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports